import { render, staticRenderFns } from "./giftManage.vue?vue&type=template&id=49a3749f"
import script from "./giftManage.vue?vue&type=script&lang=js"
export * from "./giftManage.vue?vue&type=script&lang=js"
import style0 from "./giftManage.vue?vue&type=style&index=0&id=49a3749f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a3749f')) {
      api.createRecord('49a3749f', component.options)
    } else {
      api.reload('49a3749f', component.options)
    }
    module.hot.accept("./giftManage.vue?vue&type=template&id=49a3749f", function () {
      api.rerender('49a3749f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/runActivityManage/giftManage.vue"
export default component.exports